import React from "react"
import { Trans } from "@lingui/react"
import hiveOnlineLogo from "../../view/assets/Group 419@2x.png"
import PropTypes from "prop-types"

const MaintenancePage = ({ isVisible = true }) => {
  if (!isVisible) return null

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.98)",
    zIndex: 999999,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Fira Sans",
    pointerEvents: "auto",
    userSelect: "none",
  }

  const containerStyle = {
    textAlign: "center",
    padding: "40px",
    maxWidth: "400px",
    margin: "auto",
  }

  const logoStyle = {
    height: "60px",
    width: "auto",
    maxWidth: "200px",
    marginBottom: "30px",
    objectFit: "contain",
  }

  const titleStyle = {
    color: "#E36F1E",
    fontFamily: "quicksand",
    fontWeight: "bold",
    fontSize: "24px",
    marginBottom: "20px",
  }

  const messageStyle = {
    fontFamily: "Fira Sans",
    fontSize: "18px",
    color: "#333",
    lineHeight: "1.6",
    marginBottom: "20px",
  }

  const subMessageStyle = {
    fontFamily: "Fira Sans",
    fontSize: "16px",
    color: "#666",
    lineHeight: "1.5",
  }

  return (
    <div style={overlayStyle}>
      <div style={containerStyle}>
        <img src={hiveOnlineLogo} style={logoStyle} alt="HiveOnline" />

        <h2 style={titleStyle}>
          <Trans id="maintenance.title" />
        </h2>

        <p style={messageStyle}>
          <Trans id="maintenance.message" />
        </p>

        <p style={subMessageStyle}>
          <Trans id="maintenance.sub_message" />
        </p>
      </div>
    </div>
  )
}

MaintenancePage.propTypes = {
  isVisible: PropTypes.bool,
}

export default MaintenancePage